<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>User Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">User Details</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="EWUserDetail">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWUserDetailList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">

                  <div class="form-group required">
                    <label class="control-label">Gender</label>
                    <select class="form-control" style="width: 100%;"
                            v-bind:class="{'has-error' : errors.has('gender')}"
                            v-validate="'required'" name="gender" v-model="value.gender" id="gender">
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('gender')">
                      {{ errors.first("gender") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Date of Birth</label>
                    <div class="clearfix"></div>
                    <date-picker type="date" input-class="form-control"
                                 name="date_of_birth" v-model="value.date_of_birth" lang="en"
                                 format="YYYY-MM-DD" value-type="YYYY-MM-DD" placeholder="Date of Birth"></date-picker>
                  </div>

                  <div class="form-group ">
                    <label class="control-label">NID</label>
                    <input type="text" id="nid_number" name="nid_number"
                           v-model="value.nid_number" class="form-control nid_number"
                           placeholder="NID Number">

                  </div>
                  <div class="form-group ">
                    <label class="control-label">Expiry Date</label>
                    <div class="clearfix"></div>
                    <date-picker type="date" input-class="form-control"
                                 name="date_of_birth" v-model="value.expiration_date" lang="en"
                                 format="YYYY-MM-DD" value-type="YYYY-MM-DD" placeholder="Expiry Date"></date-picker>
                  </div>
                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>ID Card/ Passport Photo</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="id_card_image"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   name="id_card_image" class="custom-file-input" id="id_card_image"
                                   @change="select_file_id_card_image">
                            <label class="custom-file-label" for="id_card_image">{{ value.id_card_image_name }}</label>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Selfie with ID Card/ Passport</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="selfie_image"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   name="selfie_image" class="custom-file-input" id="selfie_image"
                                   @change="select_file_selfie_image">
                            <label class="custom-file-label" for="selfie_image">{{ value.selfie_image_name }}</label>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Status</label>
                    <select class="form-control" style="width: 100%;"
                            v-bind:class="{'has-error' : errors.has('status')}"
                            v-validate="'required'" name="status"
                            v-model="value.status" id="status">
                      <option value="approved">Approved</option>
                      <option value="pending">Pending</option>
                      <option value="hold">Hold</option>
                      <option value="rejected">Rejected</option>
                    </select>

                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Comment</label>
                    <textarea id="comment" name="comment"
                              v-model="value.comment" class="form-control comment"
                              placeholder="Comment"
                              rows="3"></textarea>

                  </div>
                  <div class="form-group required">
                    <label class="control-label">Country</label>
                    <multiselect id="country_id" name="country_id" :options="Object.keys(pre.country_id)"
                                 :custom-label="opt => pre.country_id[opt]"
                                 v-bind:class="{'has-error' : errors.has('country_id')}"
                                 v-validate="'required'"
                                 v-model="value.country_id" class="country_id"
                                 placeholder="Select Country" :searchable="true"
                                 :multiple="false"
                                 :close-on-select="true" :show-labels="false"></multiselect>
                    <div class="help text-danger" v-show="errors.has('country_id')">
                      {{ errors.first("country_id") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">City</label>
                    <multiselect id="city_id" name="city_id" :options="Object.keys(pre.city_id)"
                                 :custom-label="opt => pre.city_id[opt]"
                                 v-bind:class="{'has-error' : errors.has('city_id')}"
                                 v-validate="'required'"
                                 v-model="value.city_id" class="city_id"
                                 placeholder="Select City" :searchable="true"
                                 :close-on-select="true" :show-labels="false"></multiselect>
                    <div class="help text-danger" v-show="errors.has('city_id')">
                      {{ errors.first("city_id") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWUserDetailForm',
  metaInfo: {
    title: 'User Details | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      id_card_image: '',
      id_card_image_name: 'Choose file',
      selfie_image: '',
      selfie_image_name: 'Choose file',
    },
    pre: {
      country_id: {}, city_id: {},
    }
  }),
  methods: {

    select_file_id_card_image: function (event) {
      try {
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.id_card_image = reader.result
          this.$set(this.value, 'id_card_image_name', event.target.files[0].name)
        }
      } catch (e) {
        // console.log(e)
      }
    },

    select_file_selfie_image: function (event) {
      try {
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.selfie_image = reader.result
          this.$set(this.value, 'selfie_image_name', event.target.files[0].name)
        }
      } catch (e) {
        // console.log(e)
      }
    },


    countryIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/3")
          .then(response => {
            resolve(response.data)
            // return response.data
          })
          .catch((error) => {
            // console.log('error ' + error)
            reject(error)
          });
      });
    },
    cityIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/2")
          .then(response => {
            resolve(response.data)
            // return response.data
          })
          .catch((error) => {
            // console.log('error ' + error)
            reject(error)
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_user_details'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_user_details/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWUserDetailList'})
          }).catch((errors) => {

            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.errors.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_user_details/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.countryIdOptions().then(country_id => {
        this.pre.country_id = country_id;
      })
      await this.cityIdOptions().then(city_id => {
        this.pre.city_id = city_id;
      })

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })

        this.value.id_card_image = ''
        this.value.selfie_image = ''

      }

      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

